// extracted by mini-css-extract-plugin
export default {"chat":"Chat_chat__yjNKe","chatContent":"Chat_chatContent__6-FSB","chatMessages":"Chat_chatMessages__5dTXv","chatInputWrapper":"Chat_chatInputWrapper__Qri8V"};